import React from "react";
import { getInitialsForAvatar } from "@/Contracts/Utils";
import Avatar from "antd/lib/avatar";
import ZTypography from "@atoms/ZTypography";
import { EFontWeights } from "@atoms/ZTypography/interface";
import ZTooltip from "@atoms/ZTooltip";
import "./ProductCatalogResultRow.less";
import { QuoteProduct } from "@/Contracts/ProposalBuilder/Block";
import { currencyFormatter } from "@/Utils/Currency";
import he from "he";

const { ZText } = ZTypography;

interface Props {
	readonly record: QuoteProduct;
	readonly showUpdateMandatoryFieldsColumn: boolean;
}

const DellProductCatalogResultRow: React.FC<Props> = props => {
	const { manufacturer_part_no } = props.record;

	return (
		<div className="product-name-container">
			<Avatar className="product-name-icon" alt="Product" shape="square">
				{getInitialsForAvatar(props.record.name)}
			</Avatar>
			<div
				className={`product-description-container ${
					props.showUpdateMandatoryFieldsColumn ? "mr-20" : "mr-13"
				}`}
			>
				<ZText colorVariant={8} weight={EFontWeights.MEDIUM}>
					{props.record.name ? props.record.name : "--"}
				</ZText>
				<ZText level={0} colorVariant={8} className="mb-2">
					{props.record.description
						? he.decode(props.record.description)
						: "--"}
				</ZText>
				<div className="product-vendor-details">
					<ZTooltip
						title={`Part no: ${
							manufacturer_part_no ? manufacturer_part_no : "--"
						}`}
						placement="topLeft"
					>
						<ZText level={0} colorVariant={8} className="w-2/4">
							Part no:{" "}
							{manufacturer_part_no ? manufacturer_part_no : "--"}
						</ZText>
					</ZTooltip>
				</div>
			</div>
			{!props.showUpdateMandatoryFieldsColumn && (
				<div className="product-pricing-container">
					<div className="text-right">
						<ZText className="product-pricing-name">
							Dell Sales Quote:{" "}
						</ZText>
						<ZText
							level={3}
							weight={EFontWeights.MEDIUM}
							className="product-pricing"
						>{`${currencyFormatter(
							props.record.sell_price,
							"Not available"
						)}`}</ZText>
					</div>
				</div>
			)}
			{props.children}
		</div>
	);
};

export default DellProductCatalogResultRow;
